var _FontAwesomeIcon, _g, _defs, _g2, _defs2, _WinnerIcon, _NotWinnerIcon, _WinnerIcon2, _NotWinnerIcon2;
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { faUser } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Avatar from './../../Avatar/Avatar';
import clsx from 'clsx';
import MatchSide from './MatchSide';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "wrapper": "pbui-YLyPR",
  "pulse-animation": "pbui-lbGb6",
  "pulse-glow-animation": "pbui-6VmdH",
  "pulse": "pbui-Dxqc-",
  "glow-animation": "pbui-18Ufe",
  "glow": "pbui-uONxS",
  "wrapper__hovering": "pbui-ymeya",
  "header": "pbui-oQpUS",
  "link": "pbui-eLc9J",
  "content": "pbui-yiWYC",
  "mobile__content": "pbui-xzRN8",
  "final": "pbui-UmFSB",
  "final--delayed": "pbui-WLMNx",
  "match__side": "pbui-juhLx",
  "match__side--reversed": "pbui-SQ1aC",
  "match__side--not-reversed": "pbui-o-46g",
  "match__side--duo": "pbui-tcUw3",
  "match__side--solo": "pbui-SaDh5",
  "team__info": "pbui-fWh-X",
  "team__info--reversed": "pbui-aptQI",
  "team__info--not-reversed": "pbui-qu4qE",
  "team__info--duo": "pbui-j0mz3",
  "team__info--solo": "pbui-IFdZw",
  "team__container": "pbui-C6L5F",
  "team__container--winner": "pbui--lxVI",
  "team__container--duo": "pbui-lGYDp",
  "trophy": "pbui-EUTT7",
  "player__info": "pbui-qmfhO",
  "player__info--reversed-duo": "pbui-iVqJt",
  "player__info--reversed-solo": "pbui-XQt-1",
  "player__info--not-reversed-duo": "pbui-GTThp",
  "player__info--not-reversed-solo": "pbui-NomGZ",
  "name": "pbui-XsHci",
  "first__name": "pbui-kYzCB",
  "last__name": "pbui-NgrpB",
  "player__image": "pbui---xVw",
  "player__image--duo": "pbui-7JwW6",
  "player__image--solo": "pbui-qzqHh",
  "player__img": "pbui-HfY-r",
  "winner": "pbui-MS4yC",
  "winner--team2": "pbui-Z92Fx",
  "winner--reversed-duo": "pbui-UnlvW",
  "winner--not-reversed-duo": "pbui-C0YZu",
  "set__wrapper": "pbui-Xhn7p",
  "set__wrapper--reversed": "pbui-EeiTV",
  "set__wrapper--not-reversed": "pbui-XpK0m",
  "set": "pbui-W6bVW",
  "set--winner": "pbui-fnjNn",
  "set--loser": "pbui--AKyi",
  "gray__bg": "pbui-r3B2b",
  "white__bg": "pbui-l86Ph",
  "green__txt": "pbui-wqaP3",
  "gray__txt": "pbui-8idzs",
  "winner__middle": "pbui-apfTa",
  "loser__middle": "pbui-YPi-O",
  "avatar": "pbui-2UR5N",
  "avatar--winner": "pbui-wFNHi",
  "avatar--loser": "pbui-X3e8i",
  "avatar--indicator": "pbui-ifydN",
  "icon--color": "pbui-wecYV",
  "row__wrapper": "pbui-JSwiq",
  "avatar__wrapper": "pbui-65i0m",
  "avatar__wrapper-2": "pbui-5w8G9",
  "name__container": "pbui-2C79t",
  "first__name__first__letter": "pbui-5-83-",
  "last__name__mobile": "pbui-LYnP9",
  "suffix__name__mobile": "pbui-e4McB",
  "row__one__divider": "pbui-668NK",
  "row__one__divider__content": "pbui-VJoQs",
  "scores__container": "pbui-FLLDv",
  "scores__wrapper": "pbui-zsz-X",
  "scores__wrapper__reverse": "pbui-XjAQ4",
  "green__classes": "pbui-3jUjl",
  "grey__classes": "pbui-0jIlH",
  "final__wrapper": "pbui-b8SaU",
  "set__one": "pbui-3Qq7t",
  "set__two": "pbui-EF-4G",
  "live__text": "pbui--JKuM",
  "delayed__text": "pbui-o4ZP9"
};
var customIconRender = function customIconRender() {
  return _FontAwesomeIcon || (_FontAwesomeIcon = /*#__PURE__*/_jsx(FontAwesomeIcon, {
    icon: faUser,
    size: "xs"
  }));
};
var NotWinnerIcon = function NotWinnerIcon(_ref) {
  var width = _ref.width,
    height = _ref.height;
  return /*#__PURE__*/_jsxs("svg", {
    width: width,
    height: height,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [_g || (_g = /*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_1146_43196)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M9.26733 2.12555C9.3813 2.40118 9.60006 2.62027 9.87553 2.73466L10.8414 3.13476C11.1171 3.24894 11.3361 3.46794 11.4503 3.7436C11.5645 4.01926 11.5645 4.32898 11.4503 4.60464L11.0505 5.56986C10.9362 5.84564 10.9361 6.15568 11.0508 6.43132L11.45 7.39626C11.5066 7.53279 11.5357 7.67913 11.5357 7.82693C11.5358 7.97473 11.5067 8.12108 11.4501 8.25763C11.3935 8.39418 11.3106 8.51824 11.2061 8.62274C11.1016 8.72723 10.9775 8.8101 10.8409 8.86661L9.87569 9.26642C9.60006 9.38039 9.38096 9.59916 9.26658 9.87462L8.86648 10.8405C8.7523 11.1162 8.53329 11.3352 8.25764 11.4494C7.98198 11.5636 7.67226 11.5636 7.3966 11.4494L6.43138 11.0496C6.15571 10.9357 5.8461 10.9359 5.57061 11.0502L4.60469 11.4497C4.32919 11.5637 4.01973 11.5636 3.7443 11.4495C3.46887 11.3354 3.24998 11.1166 3.13572 10.8413L2.73551 9.87507C2.62154 9.59944 2.40277 9.38034 2.12731 9.26596L1.16139 8.86586C0.885857 8.75173 0.666914 8.53286 0.552691 8.25736C0.438468 7.98187 0.438313 7.67229 0.552261 7.39667L0.952069 6.43145C1.06597 6.15579 1.06574 5.84617 0.951422 5.57068L0.552188 4.60407C0.495584 4.46754 0.466438 4.3212 0.466414 4.1734C0.466391 4.0256 0.49549 3.87925 0.552049 3.7427C0.608609 3.60615 0.691521 3.48209 0.796046 3.3776C0.900572 3.27311 1.02466 3.19023 1.16123 3.13372L2.12645 2.73391C2.40185 2.62004 2.62081 2.40155 2.73528 2.1264L3.13537 1.16049C3.24955 0.884831 3.46856 0.665823 3.74422 0.551642C4.01988 0.437462 4.3296 0.437462 4.60526 0.551642L5.57048 0.951451C5.84614 1.06535 6.15576 1.06512 6.43125 0.950804L7.39757 0.552262C7.67319 0.438146 7.98285 0.438169 8.25845 0.552327C8.53405 0.666486 8.75303 0.885431 8.86723 1.16102L9.26745 2.12722L9.26733 2.12555Z",
        fill: "#D92D20"
      }), /*#__PURE__*/_jsx("path", {
        d: "M8.5 3.5L3.5 8.5M3.5 3.5L8.5 8.5",
        stroke: "white",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })]
    })), _defs || (_defs = /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_1146_43196",
        children: /*#__PURE__*/_jsx("rect", {
          width: "12",
          height: "12",
          fill: "white"
        })
      })
    }))]
  });
};
var WinnerIcon = function WinnerIcon(_ref2) {
  var width = _ref2.width,
    height = _ref2.height;
  return /*#__PURE__*/_jsxs("svg", {
    width: width,
    height: height,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [_g2 || (_g2 = /*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_1146_43193)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M9.26684 2.12555C9.38081 2.40118 9.59958 2.62027 9.87504 2.73466L10.841 3.13476C11.1166 3.24894 11.3356 3.46794 11.4498 3.7436C11.564 4.01926 11.564 4.32898 11.4498 4.60464L11.05 5.56986C10.9358 5.84564 10.9356 6.15568 11.0504 6.43132L11.4495 7.39626C11.5061 7.53279 11.5352 7.67913 11.5352 7.82693C11.5353 7.97473 11.5062 8.12108 11.4496 8.25763C11.393 8.39418 11.3101 8.51824 11.2056 8.62274C11.1011 8.72723 10.977 8.8101 10.8404 8.86661L9.8752 9.26642C9.59957 9.38039 9.38047 9.59916 9.26609 9.87462L8.86599 10.8405C8.75181 11.1162 8.53281 11.3352 8.25715 11.4494C7.98149 11.5636 7.67177 11.5636 7.39611 11.4494L6.43089 11.0496C6.15522 10.9357 5.84561 10.9359 5.57012 11.0502L4.6042 11.4497C4.3287 11.5637 4.01924 11.5636 3.74381 11.4495C3.46838 11.3354 3.24949 11.1166 3.13523 10.8413L2.73502 9.87507C2.62105 9.59944 2.40228 9.38034 2.12682 9.26596L1.16091 8.86586C0.885369 8.75173 0.666426 8.53286 0.552203 8.25736C0.43798 7.98187 0.437825 7.67229 0.551772 7.39667L0.951581 6.43145C1.06548 6.15579 1.06525 5.84617 0.950934 5.57068L0.551699 4.60407C0.495096 4.46754 0.46595 4.3212 0.465926 4.1734C0.465902 4.0256 0.495001 3.87925 0.551561 3.7427C0.608121 3.60615 0.691033 3.48209 0.795558 3.3776C0.900084 3.27311 1.02417 3.19023 1.16074 3.13372L2.12596 2.73391C2.40136 2.62004 2.62032 2.40155 2.73479 2.1264L3.13489 1.16049C3.24907 0.884831 3.46807 0.665823 3.74373 0.551642C4.01939 0.437462 4.32911 0.437462 4.60477 0.551642L5.56999 0.951451C5.84566 1.06535 6.15527 1.06512 6.43076 0.950804L7.39708 0.552262C7.6727 0.438146 7.98236 0.438169 8.25796 0.552327C8.53357 0.666486 8.75254 0.885431 8.86674 1.16102L9.26696 2.12722L9.26684 2.12555Z",
        fill: "#099250"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.34995 4.42755C8.43011 4.30164 8.45697 4.14904 8.42462 4.00333C8.39227 3.85761 8.30336 3.73071 8.17745 3.65055C8.05153 3.57039 7.89894 3.54353 7.75322 3.57588C7.6075 3.60823 7.48061 3.69714 7.40045 3.82305L5.1977 7.2843L4.1897 6.0243C4.09651 5.90774 3.96083 5.83297 3.81251 5.81644C3.66419 5.79992 3.51538 5.84299 3.39882 5.93618C3.28226 6.02937 3.20749 6.16504 3.19096 6.31336C3.17444 6.46168 3.21751 6.61049 3.3107 6.72705L4.8107 8.60205C4.8666 8.67202 4.9384 8.72762 5.02012 8.76425C5.10185 8.80087 5.19114 8.81745 5.28056 8.81261C5.36999 8.80777 5.45696 8.78164 5.53426 8.73641C5.61155 8.69118 5.67692 8.62814 5.72495 8.55255L8.34995 4.42755Z",
        fill: "white"
      })]
    })), _defs2 || (_defs2 = /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_1146_43193",
        children: /*#__PURE__*/_jsx("rect", {
          width: "12",
          height: "12",
          fill: "white"
        })
      })
    }))]
  });
};
var PlayersRow = function PlayersRow(_ref3) {
  var match = _ref3.match,
    playerIndex = _ref3.playerIndex,
    player1FirstName = _ref3.player1FirstName,
    player1LastName = _ref3.player1LastName,
    player1SuffixName = _ref3.player1SuffixName,
    player2FirstName = _ref3.player2FirstName,
    player2LastName = _ref3.player2LastName,
    player2SuffixName = _ref3.player2SuffixName;
  var rowWrapperClasses = clsx(styles.row__wrapper);
  var avatarTeam1Classes = clsx(styles.avatar, match.team1.isWinner ? styles['avatar--winner'] : match.team1.isWinner !== undefined && styles['avatar--loser']);
  var avatarTeam2Classes = clsx(styles.avatar, match.team2.isWinner ? styles['avatar--winner'] : match.team2.isWinner !== undefined && styles['avatar--loser']);
  return /*#__PURE__*/_jsxs("div", {
    className: rowWrapperClasses,
    children: [match.team1.players[playerIndex] && /*#__PURE__*/_jsxs("div", {
      className: styles['avatar__wrapper'],
      children: [/*#__PURE__*/_jsx(Avatar, {
        className: avatarTeam1Classes,
        size: "xs",
        imageUrl: match.team1.players[playerIndex].image,
        customIconRender: customIconRender,
        onlineIndicator: /*#__PURE__*/_jsx("div", {
          className: styles['avatar--indicator'],
          children: match.team1.isWinner ? _WinnerIcon || (_WinnerIcon = /*#__PURE__*/_jsx(WinnerIcon, {
            width: 14,
            height: 14
          })) : match.team1.isWinner !== undefined ? _NotWinnerIcon || (_NotWinnerIcon = /*#__PURE__*/_jsx(NotWinnerIcon, {
            width: 14,
            height: 14
          })) : null
        })
      }, match.team1.players[playerIndex].playerId), /*#__PURE__*/_jsxs("div", {
        className: styles['name__container'],
        children: [player1FirstName && /*#__PURE__*/_jsxs("span", {
          className: styles['first__name__first__letter'],
          children: [player1FirstName.charAt(0).toUpperCase(), ". \xA0"]
        }), player1LastName && /*#__PURE__*/_jsx("span", {
          className: styles['last__name__mobile'],
          children: player1LastName
        }), " ", player1SuffixName && /*#__PURE__*/_jsxs("span", {
          className: styles['suffix__name__mobile'],
          children: ["\xA0", player1SuffixName]
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: styles['row__one__divider'],
      children: /*#__PURE__*/_jsx("div", {
        className: styles['row__one__divider__content']
      })
    }), match.team2.players[playerIndex] && /*#__PURE__*/_jsxs("div", {
      className: styles['avatar__wrapper-2'],
      children: [/*#__PURE__*/_jsx(Avatar, {
        className: avatarTeam2Classes,
        size: "xs",
        imageUrl: match.team2.players[playerIndex].image,
        customIconRender: customIconRender,
        onlineIndicator: /*#__PURE__*/_jsx("div", {
          className: styles['avatar--indicator'],
          children: match.team2.isWinner ? _WinnerIcon2 || (_WinnerIcon2 = /*#__PURE__*/_jsx(WinnerIcon, {
            width: 14,
            height: 14
          })) : match.team2.isWinner !== undefined ? _NotWinnerIcon2 || (_NotWinnerIcon2 = /*#__PURE__*/_jsx(NotWinnerIcon, {
            width: 14,
            height: 14
          })) : null
        })
      }, match.team2.players[playerIndex].playerId), /*#__PURE__*/_jsxs("div", {
        className: styles['name__container'],
        children: [player2FirstName && /*#__PURE__*/_jsxs("span", {
          className: styles['first__name__first__letter'],
          children: [player2FirstName.charAt(0).toUpperCase(), ". \xA0"]
        }), player2LastName && /*#__PURE__*/_jsx("span", {
          className: styles['last__name__mobile'],
          children: player2LastName
        }), player2SuffixName && /*#__PURE__*/_jsxs("span", {
          className: styles['suffix__name__mobile'],
          children: ["\xA0", player2SuffixName]
        })]
      })]
    })]
  });
};
var ResultCard = function ResultCard(_ref4) {
  var _match$team1$scores;
  var match = _ref4.match,
    rounded = _ref4.rounded,
    animation = _ref4.animation;
  var wrapperClasses = clsx(styles.wrapper, rounded && styles['wrapper__hovering'], {
    'pulse': styles["pulse-animation"],
    'glow': styles["glow-animation"],
    'pulse-glow': styles["pulse-glow-animation"]
  }[animation]);
  var contentClasses = clsx(styles.content);
  var mobileContentClasses = clsx(styles.mobile__content);
  var finalClasses = clsx(styles["final"], match.matchStatus === 3 && styles['final--delayed']);
  var setClasses = clsx(styles.set__one);
  var set2Classes = clsx(styles.set__two);
  var finalWrapperClasses = clsx(styles.final__wrapper);
  return /*#__PURE__*/_jsxs("div", {
    className: wrapperClasses,
    children: [/*#__PURE__*/_jsxs("div", {
      className: contentClasses,
      children: [/*#__PURE__*/_jsx(MatchSide, {
        team: match.team1,
        oppositeTeam: match.team2,
        teamLabel: "team1",
        matchStatus: match.matchStatus,
        gameOneEndDate: match.gameOneEndDate,
        gameTwoEndDate: match.gameTwoEndDate,
        gameThreeEndDate: match.gameThreeEndDate,
        gameFourEndDate: match.gameFourEndDate,
        gameFiveEndDate: match.gameFiveEndDate
      }), /*#__PURE__*/_jsx("div", {
        className: finalClasses,
        children: match.matchStatus === 2 ? /*#__PURE__*/_jsx("span", {
          className: styles['live__text'],
          children: "Live"
        }) : match.matchStatus === 3 ? /*#__PURE__*/_jsx("span", {
          className: styles['delayed__text'],
          children: "Delayed"
        }) : match.matchStatus === 4 ? 'Final' : ''
      }), /*#__PURE__*/_jsx(MatchSide, {
        team: match.team2,
        oppositeTeam: match.team1,
        teamLabel: "team2",
        matchStatus: match.matchStatus,
        gameOneEndDate: match.gameOneEndDate,
        gameTwoEndDate: match.gameTwoEndDate,
        gameThreeEndDate: match.gameThreeEndDate,
        gameFourEndDate: match.gameFourEndDate,
        gameFiveEndDate: match.gameFiveEndDate
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: mobileContentClasses,
      children: [match.team1.players[0] && match.team2.players[0] && /*#__PURE__*/_jsx(PlayersRow, {
        match: match,
        playerIndex: 0,
        player1FirstName: match.team1.players[0].firstName,
        player1LastName: match.team1.players[0].lastName,
        player1SuffixName: match.team1.players[0].suffixName,
        player2FirstName: match.team2.players[0].firstName,
        player2LastName: match.team2.players[0].lastName,
        player2SuffixName: match.team2.players[0].suffixName
      }), /*#__PURE__*/_jsxs("div", {
        className: styles['scores__container'],
        children: [/*#__PURE__*/_jsx("div", {
          className: styles['scores__wrapper'],
          children: match.team1.scores.length > 0 && ((_match$team1$scores = match.team1.scores) == null ? void 0 : _match$team1$scores.map(function (setValue, index) {
            var value = setValue === 0 && match.team2.scores[index] === 0 ? '-' : setValue;
            var isGameOver = false;
            if (match.matchStatus === 4) {
              isGameOver = true;
            } else if (index === 0 && match.gameOneEndDate) {
              isGameOver = true;
            } else if (index === 1 && match.gameTwoEndDate) {
              isGameOver = true;
            } else if (index === 2 && match.gameThreeEndDate) {
              isGameOver = true;
            } else if (index === 3 && match.gameFourEndDate) {
              isGameOver = true;
            } else if (index === 4 && match.gameFiveEndDate) {
              isGameOver = true;
            }
            var isGameWinner = setValue > match.team2.scores[index];
            return /*#__PURE__*/_jsx("div", {
              className: "".concat(setClasses, "\n                        ").concat(isGameOver && isGameWinner ? styles['green__classes'] : styles['grey__classes'], "\n                    "),
              children: value
            }, index);
          }))
        }), /*#__PURE__*/_jsx("div", {
          className: finalWrapperClasses,
          children: match.matchStatus === 2 ? /*#__PURE__*/_jsx("span", {
            className: styles['live__text'],
            children: "Live"
          }) : match.matchStatus === 3 ? /*#__PURE__*/_jsx("span", {
            className: styles['delayed__text'],
            children: "Delayed"
          }) : match.matchStatus === 4 ? 'Final' : ''
        }), /*#__PURE__*/_jsx("div", {
          className: styles['scores__wrapper__reverse'],
          children: match.team2.scores.length > 0 && match.team2.scores.map(function (setValue, index) {
            var value = setValue === 0 && match.team1.scores[index] === 0 ? '-' : setValue;
            var isGameOver = false;
            if (match.matchStatus === 4) {
              isGameOver = true;
            } else if (index === 0 && match.gameOneEndDate) {
              isGameOver = true;
            } else if (index === 1 && match.gameTwoEndDate) {
              isGameOver = true;
            } else if (index === 2 && match.gameThreeEndDate) {
              isGameOver = true;
            } else if (index === 3 && match.gameFourEndDate) {
              isGameOver = true;
            } else if (index === 4 && match.gameFiveEndDate) {
              isGameOver = true;
            }
            var isGameWinner = setValue > match.team1.scores[index];
            return /*#__PURE__*/_jsx("div", {
              className: "".concat(set2Classes, "\n                      ").concat(isGameOver && isGameWinner ? styles['green__classes'] : styles['grey__classes'], "\n                    "),
              children: value
            }, index);
          })
        })]
      }), match.team1.players[1] && match.team2.players[1] && /*#__PURE__*/_jsx(PlayersRow, {
        match: match,
        playerIndex: 1,
        player1FirstName: match.team1.players[1].firstName,
        player1LastName: match.team1.players[1].lastName,
        player1SuffixName: match.team1.players[1].suffixName,
        player2FirstName: match.team2.players[1].firstName,
        player2LastName: match.team2.players[1].lastName,
        player2SuffixName: match.team2.players[1].suffixName
      })]
    })]
  });
};
export default ResultCard;